import styled from "styled-components";
import PinkGradient from "../../assets/faded-pink-gradient.png";
import { siteDarkBlue } from "../../providers/Theme";

export const BandSection = styled.section`
  position: relative;
  z-index: 0;
  padding: 4rem 1.5rem;
  text-align: center;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url(${PinkGradient});
    background-size: cover;
    background-position: center;
    z-index: 0;
  }
`;

export const BandInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 72rem;
  margin: 0 auto;
`;

export const BandHeading = styled.h2`
  color: ${siteDarkBlue};
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1.25rem;

  font-size: 2rem;

  ${({ theme }) => theme.md`
    font-size: 2.5rem;
  `}

  ${({ theme }) => theme.xl`
    font-size: 3rem;
  `}
`;

export const BandBody = styled.p`
  color: ${siteDarkBlue};
  font-size: 1.35rem;
  line-height: 1.7;
  max-width: 64rem;
  margin: 0 auto;

  ${({ theme }) => theme.md`
    font-size: 1.5rem;
  `}
`;
